import { createFileRoute } from '@tanstack/react-router'

import { RequestsPage } from '@/features/account/pages/requests-page'

export interface RequestsSearch {
  /** G1 inbox scope filter (deep-link / preserved). */
  scope?: string
  /** G1 inbox status filter (deep-link / preserved). */
  status?: string
  /** Exact request selected from a notification. */
  request?: string
}

/** G1 — Resource-request inbox. */
export const Route = createFileRoute('/_ws/w/$workspaceId/requests')({
  validateSearch: (search: Record<string, unknown>): RequestsSearch => ({
    scope: typeof search.scope === 'string' ? search.scope : undefined,
    status: typeof search.status === 'string' ? search.status : undefined,
    request: typeof search.request === 'string' ? search.request : undefined,
  }),
  component: RequestsPage,
})
